export enum ProductListTypes {
    fav = 'Favorites',
    buyAgain = 'Buy again'
}